import React, { useEffect } from 'react';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import { getSimilarData } from '../../../Utils/helper';
import ProductCardNew from '../../StoreCategoryPage/SubCategoryProducts/ProductCardNew';
import { ArticleProductContainer, Title } from './styled';

export default function ArticleProductCard(props) {
  const {
    productArray,
    similarElements,
    setAddedToCart,
    rupeeSymbol,
    heading,
    fromBabyNames,
    tabData,
    query_add,
  } = props;
  const product = productArray
    ? productArray
    : getSimilarData(similarElements, 'product');
  useEffect(() => {
    cardServedEvent(tabData, true);
  }, []);
  return (
    <>
      {product?.length > 0 ? (
        <ArticleProductContainer fromBabyNames={fromBabyNames}>
          <Title fromBabyNames={fromBabyNames} as="h3">
            {heading ? heading : 'Products you may like'}
          </Title>
          {/* <AnywhereHorizontalScroll
                        firstElementId={`${product[0]?.name}first`}
                        lastElementId={`${
                            product[product.length - 1]?.name
                        }last`}
                        leftArrow={
                            <img
                                src={images.arrowDownForward}
                                alt="scrollArrow"
                            />
                        }
                        rightArrow={
                            <img
                                src={images.arrowDownForward}
                                alt="scrollArrow"
                            />
                        }
                        scrolledWidth={440}
                    > */}
          <div className="bestSellerContainer">
            {product.map((element, index) => {
              return (
                <ProductCardNew
                  data={element}
                  id={
                    index == 0
                      ? `${element?.name}first`
                      : index == product.length - 1
                        ? `${element?.name}last`
                        : `articleproductCards${index}`
                  }
                  mobileWidth={'44%'}
                  shrink={'0'}
                  article={false}
                  setAddedToCart={setAddedToCart}
                  showPrice={true}
                  maxWidth={'22%'}
                  storeHome={true}
                  rupeeSymbol={rupeeSymbol}
                  key={`article-${index}`}
                  fromBabyNames={fromBabyNames}
                  category_name={heading}
                  section={tabData}
                  query_add={query_add}
                />
              );
            })}
          </div>
          {/* </AnywhereHorizontalScroll> */}
        </ArticleProductContainer>
      ) : null}
    </>
  );
}
